import React, { useEffect } from "react";
import { Box, Divider, Typography } from "@mui/material";
import ClickAndEditText from "../ClickAndEditText";

let timeout = null;
const ScoreDefinitionCard = ({
	score,
	index,
	title,
	color,
	editing,
	onUpdateScore = () => {},
	onUpdateTitle = () => {},
}) => {
	const [score_title, setScoreTitle] = React.useState(title);
	const [score_definition, setScoreDefinition] = React.useState(
		score?.definition
	);

	const updateScore = (updates) => {
		if (timeout) clearTimeout(timeout);
		timeout = setTimeout(() => {
			onUpdateScore(score?.score_id, updates);
		}, 1000);
	};

	const updateTitle = (value) => {
		if (timeout) clearTimeout(timeout);
		timeout = setTimeout(() => {
			onUpdateTitle(index, value);
		}, 1000);
	};

	useEffect(() => {
		setScoreTitle(title);
	}, [title]);
	useEffect(() => {
		setScoreDefinition(score?.definition);
	}, [score]);
	return (
		<Box
			sx={{
				width: "200px",
				minWidth: "200px",
				bgcolor: "#F9FAFB",
				p: "12px 16px",
				display: "flex",
				flexDirection: "column",
				gap: "8px",
				borderRadius: "16px",
			}}>
			<Box
				sx={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
				}}>
				<ClickAndEditText
					editable={editing}
					value={score_title}
					onChange={(value) => {
						setScoreTitle(value);
						updateTitle(value);
					}}
					placeholder={editing ? "Score Title" : ""}
					sx={{
						fontSize: 16,
						fontWeight: 500,
						color: !score_title ? "" : color,
					}}
				/>

				<Typography
					fontSize={16}
					fontWeight={500}>
					{score?.level}
				</Typography>
			</Box>

			<Divider />
			<Box>
				<ClickAndEditText
					editable={editing}
					value={score_definition}
					onChange={(value) => {
						setScoreDefinition(value);
						updateScore({ definition: value });
					}}
					placeholder="Score Definition"
					sx={{ fontSize: 12, fontWeight: 400 }}
					InputBaseProps={{
						multiline: true,
					}}
				/>
			</Box>
		</Box>
	);
};

export default React.memo(ScoreDefinitionCard);
